import { useEntityDrawer } from '../context/EntityDrawerContext';

/**
 * EntityLink — renders a clickable name that opens the right panel/page.
 * 
 * Usage:
 *   <EntityLink type="contractor" id={row.contractor_id}>{row.contractor_name}</EntityLink>
 *   <EntityLink type="vendor" id={row.vendor_id}>{row.vendor_name}</EntityLink>
 *   <EntityLink type="ar_invoice" id={row.ar_invoice_id}>{row.ar_invoice_number}</EntityLink>
 */
export default function EntityLink({ type, id, children, style }) {
  const { openEntity } = useEntityDrawer();

  if (!id || !type) {
    return <span style={style}>{children}</span>;
  }

  return (
    <button
      onClick={e => { e.stopPropagation(); openEntity(type, id); }}
      style={{
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        color: 'var(--accent)',
        fontWeight: 600,
        fontSize: 'inherit',
        textDecoration: 'none',
        textAlign: 'left',
        ...style,
      }}
      title={`View ${type.replace('_', ' ')}`}
    >
      {children}
    </button>
  );
}
